var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"beneficiary-info",class:_vm.clazz},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.imgUrl,"width":"42","height":"42","alt":"Imagen beneficiario"}}),_c('span',{staticClass:"info",class:_vm.clazzInfo},[_c('label',[_vm._v(_vm._s(_vm.text))]),_c('p',[_vm._v(_vm._s(_vm.textBold))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }